import { Box, Icon, List, ListItem, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { CustomTable } from "../../../../../../components"
import { useRef } from "react"
import { RefTable } from "../../../../../../components/table/types"
import { useContextState } from "../../../../../../hooks/theme"
import { useStyles } from "./styles"
import { icons } from "../../../../../../utils/icons"
import { CheckCell } from "../checkCell"
import { FilterBody } from "../../../../../../hooks/filter/typing"

export const PermissionFile = ( { row, isLoading, filterPermissions, totalPages } : { totalPages: number; row:any, isLoading:boolean, filterPermissions: FilterBody} ) => {

    const { t } = useTranslation()
    const refTable = useRef<RefTable>(null)
    const { colors } = useContextState()
    const styles = useStyles()
    const { paginationModel, handlePagination } = filterPermissions;

    const column = [
        {
          id: 'name',
          label: t('general.tags.name'),
          sortable: true,
        },
        {
          id: 'roleName',
          label: t('general.tags.role'),
          sortable: true,
        },
        {
          id: 'areaName',
          label: t('general.tags.area'),
          sortable: true,
          renderCell: (params: any) => {
            const areaArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
            const firstTwoAreas = areaArray?.slice(0, 2);
            const remainingAreas = areaArray?.slice(2);
            return (
              <Box>
                <Typography sx={styles.areaTitle}>
                  {firstTwoAreas?.join(', ')}
                  {remainingAreas?.length > 0 && (
                    <Tooltip
                      title={
                        <List>
                          {remainingAreas.map((item: string, index: number) => (
                            <ListItem key={index} style={{ padding: 0 }}>
                              {item}
                            </ListItem>
                          ))}
                        </List>
                      }
                    >
                      <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                    </Tooltip>
                  )}
                  {!areaArray && 'N/A'}
                </Typography>
              </Box>
            )
          },
        },
        {
          id: 'departmentName',
          label: t('general.tags.department'),
          sortable: true,
          renderCell: (params: any) => {
            const departmentArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
            const firstTwoDepartments = departmentArray?.slice(0, 2);
            const remainingDepartments = departmentArray?.slice(2);
            return (
              <Box /* sx={styles.containerStatus} */>
                <Typography sx={styles.areaTitle}>
                  {firstTwoDepartments?.join(', ')}
                  {remainingDepartments?.length > 0 && (
                    <Tooltip
                      title={
                        <List>
                          {remainingDepartments.map((item: string, index: number) => (
                            <ListItem key={index} style={{ padding: 0 }}>
                              {item}
                            </ListItem>
                          ))}
                        </List>
                      }
                    >
                      <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                    </Tooltip>
                  )}
                  {!departmentArray && 'N/A'}
                </Typography>
              </Box>
            )
          },
        },
        {
          id: 'userTypeDescription',
          label: t('general.tags.userType'),
        },
        {
          id: 'seeFile',
          label: t('general.tags.seeFile'),
          minWidth: 100,
          headerCell: {
            '&.header-cell.header-cell': {
              whiteSpace: 'normal'
            }
          },
          renderCell: (params: any) => {
            return (
              <CheckCell value={params.current}/>
            )
          },
        },
        {
          id: 'downloadFile',
          label: t('general.tags.downloadFile'),
          minWidth: 100,
          headerCell: {
            '&.header-cell.header-cell': {
              whiteSpace: 'normal'
            }
          },
          renderCell: (params: any) => {
            return (
              <CheckCell value={params.current}/>
            )
          },
        }
      ]

    return (
        <Box>
            <Typography sx={styles.titlesTab}>{t('filesManager.titles.usersWithPermission')}</Typography>

            <CustomTable
                ref={refTable}
                loader={isLoading}
                dontRefresh
                column={column}
                row={row ?? []}
                color={colors}
                serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    handlePagination({ page, pageSize })
                }}
            />
        </Box>
    )
}